var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('actions-toolbar'),_vm._v(" "),_c('v-divider'),_c('conversation-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }